module.exports = __webpack_public_path__ + "static/media/Pic_Girl and Musio talking.035b6a1b.svg";